export const getModalInfo = (error, message) => {
  if (
    error &&
    message ===
      "You have active dealerships. Please terminate them in “Firms” section in My Account and try again."
  )
    return {
      showWarning: true,
      headerText: "Active dealerships found!",
      subHeaderText: message,
    };
  return {
    showWarning: false,
    headerText: "Are you sure you want to delete your account?",
    subHeaderText: message,
  };
};
